import { render, staticRenderFns } from "./righttip.vue?vue&type=template&id=1693d99f&scoped=true"
import script from "./righttip.vue?vue&type=script&lang=js"
export * from "./righttip.vue?vue&type=script&lang=js"
import style0 from "./righttip.vue?vue&type=style&index=0&id=1693d99f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1693d99f",
  null
  
)

export default component.exports